import { HardDrive } from "lucide-react";
import { useHostSystemDf } from "@/hooks/useDocker";

function human(bytes: number): string {
  if (bytes >= 1024 ** 3) return `${(bytes / 1024 ** 3).toFixed(1)} Go`;
  if (bytes >= 1024 ** 2) return `${(bytes / 1024 ** 2).toFixed(0)} Mo`;
  return `${(bytes / 1024).toFixed(0)} Ko`;
}

/** Compact disk-usage footer for a host (Docker-Desktop "Disk usage"). */
export function SystemDfBar({ hostId }: { hostId: number }) {
  const { data } = useHostSystemDf(hostId);
  if (!data) return null;

  const items: [string, { count: number; size: number }][] = [
    ["Images", data.images],
    ["Conteneurs", data.containers],
    ["Volumes", data.volumes],
    ["Build cache", data.build_cache],
  ];

  return (
    <div className="flex flex-wrap items-center gap-4 rounded-lg border border-gray-800 bg-gray-900/40 px-4 py-2 text-sm">
      <HardDrive className="h-4 w-4 text-gray-500" />
      {items.map(([label, v]) => (
        <div key={label} className="flex items-center gap-1.5">
          <span className="text-gray-400">{label}</span>
          <span className="text-gray-100">{human(v.size)}</span>
          <span className="text-xs text-gray-600">({v.count})</span>
        </div>
      ))}
    </div>
  );
}
